import { OnInit, Component, Optional, Inject } from '@angular/core';
import { OrderStatusEventEmitterService } from '../../services/orderStatusEventEmitterService.component';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { NxiContextUtils } from '@pershing/nxi-common';
import { Subscription } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { OSFService } from '../../services/OSFService.component';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { PershingTranslationService } from '@pershing/pershing-core';
import { OSCancelPopupComponent } from '../OSCancelPopup/OSCancelPopup.component';
@Component({
  selector: 'new-order-status',
  templateUrl: './NewOrderStatus.component.html',
  styleUrls: ['./NewOrderStatus.component.css'],
  providers: [DatePipe]
})
export class NewOrderStatusComponent implements OnInit {
  data: any;
  loading: boolean = true;
  activeSort: string = '';
  reverseSort: boolean;
  offset: any;
  clientDate: any;
  utc: any;
  serverDate: any;
  serverDateString: string;
  timematcher: any;
  monthpicker: Array<any>= ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  serviceUrl: any;
  acctRef: any;
  subs: Subscription;
  summeryData: any;
  description: any;
  today: any;
  dd: any;
  mm: any;
  yyyy: any;
  myDate: any;
  mytime: any;
  ismobile: boolean = false;
  isAdaTheme: boolean = false;
  isFirstFunc: boolean = false;
  isearlyFunc: boolean = false;
  isdisplayFunc: boolean = false;
  constructor(
    private  osfservice: OSFService, private eventEmitterService: OrderStatusEventEmitterService,  private nxiRestService: NxiRestService, private contextService: IContextService,
    private http: HttpClient, private datePipe: DatePipe, private dialog: MatDialog,
    private translationService: PershingTranslationService, @Optional() @Inject('AppSettings') appSettings: any) {
      this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
      if (appSettings.deviceType === 'mobile') {
        this.ismobile = true;
      }
      if (appSettings.themeType && appSettings.themeType === 'ada') {
        this.isAdaTheme = true;
      }
     }

  ngOnInit() {
    if (this.eventEmitterService.subsVar === undefined) {
      this.eventEmitterService.subsVar = this.eventEmitterService.
        invokeFirstComponentFunction.subscribe((name: string) => {
          this.firstFunction();
        });
    }
    if (this.eventEmitterService.subsVar2 === undefined) {
      this.eventEmitterService.subsVar2 = this.eventEmitterService.
       invokeFirstComponentFunction.subscribe((name: string) => {
        this.earlyLoading();
        });
      }
    this.displaytime();
  }
  firstFunction() {
    this.isFirstFunc = true;
    this.data = this.eventEmitterService.get();
    console.log('data in summary componenet', this.data);
  }
  earlyLoading() {
    this.isearlyFunc = true;
    this.loading = false;
  }
  sort(att) {
    if (att === this.activeSort) {
      this.reverseSort = !this.reverseSort;
      if (!this.reverseSort) {
        this.data.sort((a, b) => (a[att] > b[att]) ? 1 : -1);
      }else {
        this.data.sort((a, b) => (a[att] < b[att]) ? 1 : -1);
      }
    }else {
      this.activeSort = att;
      this.reverseSort = false;
      this.data.sort((a, b) => (a[att] > b[att]) ? 1 : -1);
    }
  }
  convertToServerDateZone(att) {
  this.offset = -5.0;
  this.clientDate = new Date(att);
  this.utc = this.clientDate.getTime() + (this.clientDate.getTimezoneOffset() * 60000);
  this.serverDate = new Date(this.utc + (3600000 * this.offset));
  this.serverDateString = this.serverDate.toString();
  if ( this.monthpicker.indexOf(this.serverDateString.substring(4, 7)) < 10 ) {
   return ('0' + this.monthpicker.indexOf(this.serverDateString.substring(4, 7)) + '/' + this.serverDateString.substring(8, 10) + '/' + this.serverDateString.substring(11, 15));
  }else {
   return (this.monthpicker.indexOf(this.serverDateString.substring(4, 7)) + '/' + this.serverDateString.substring(8, 10) + '/' + this.serverDateString.substring(11, 15));
  }
  }
  convertToServerTimeZone(att) {
  this.offset = -5.0;
  this.clientDate = new Date(att);
  this.utc = this.clientDate.getTime() + (this.clientDate.getTimezoneOffset() * 60000);
  this.serverDate = new Date(this.utc + (3600000 * this.offset));
  this.serverDateString = this.serverDate.toString();
  if ( this.serverDateString[16] === '0' ) {
    return (this.serverDateString.substring(17, 25) + 'AM ET');
  }else {
    this.timematcher = parseInt(this.serverDateString.substring(16, 18), 10) - 12;
    return (this.timematcher + this.serverDateString.substring(18, 25) + 'PM ET');
  }
  }
  getData(att,  ordDtlKey, subRequestTypeCode, ordProdCodeText, ordPriceTypeCode, j ) {
    if (this.data[j]['description1'] === undefined) {
      this.getaccurl( ordDtlKey, subRequestTypeCode, ordProdCodeText, ordPriceTypeCode, j);
    }
    return !att ;
  }
  getaccurl( ordDtlKey, subRequestTypeCode, ordProdCodeText, ordPriceTypeCode, j) {
  this.serviceUrl = this.nxiRestService.serviceUrl ;
  this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
  let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
  this.acctRef = contextValue.hashValue;
  let params = new HttpParams();
  if (subRequestTypeCode) {
    params = params.append('subRequestTypeCode', subRequestTypeCode);
   }
  params = params.append('ordProdCodeText', ordProdCodeText);
  params = params.append('ordPriceTypeCode', ordPriceTypeCode);
  // this.http.get(this.serviceUrl + '/trading/' + this.acctRef + '/order/' + ordDtlKey + '/details?' , { params }).subscribe(
  this.osfservice.getDetailedOrderStatus(this.serviceUrl, this.acctRef, ordDtlKey, params).subscribe(
    data => {
    this.summeryData = data;
    console.log('writing summary data', this.summeryData);
    this.data[j]['description1'] = this.summeryData.instrument.description;
    this.data[j]['rejectDescription1'] = this.summeryData.rejectDescription;
    }
    );
  });
  }
  displaytime() {
    this.isdisplayFunc = true;
    this.myDate = new Date().toLocaleString('en-US', {timeZone: 'America/New_York'});
    this.mytime = this.myDate;
    this.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.mytime = this.datePipe.transform(this.mytime, 'h:mm a');

  }
  cancelPopup(att1, att2, att3, att4, att5, att6, att7, att8, att9) {
    console.log('description', att9);
    this.dialog.open(OSCancelPopupComponent, { disableClose: true, data: { datakey1: att1, datakey2: att2, datakey3: att3, datakey4: att4,
      datakey5: att5, datakey6: att6, datakey7: att7, datakey8: att8, datakey9: att9} });
  }
}
